module.exports = __webpack_public_path__ + "img/dakai.fw.1ff35324.png";